<div class="flex-center">
  <img
    [attr.width]="width"
    [attr.height]="height"
    [src]="'assets/images/svg/' + name + '.svg'"
    [attr.class]="class"
    [attr.alt]="name + ' icon'"
  />
</div>
